import React from "react";

export default function PlaceholderPage({ title }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-600 p-4">
      <div className="bg-gray-600 rounded-lg shadow-md p-8 w-full max-w-3xl text-center">
        <h1 className="text-lg md:text-xl lg:text-2xl font-bold text-yellow-200 mb-4">
          {title}
        </h1>
        <p className="text-white text-sm md:text-base lg:text-lg">
          This is a placeholder page for <span className="font-semibold">{title}</span>.
          Content for this page will be implemented here.
        </p>
        <div className="mt-6">
          <button
            onClick={() => window.history.back()}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition"
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}
